import axios from 'axios';
import { baseApi, token } from '../../../services/Apis';

export const tiposEventosApi = `${baseApi}/event-types`;

export const getAllTiposEventosService = async (params) => {
  // params.active = true;
  const res = await axios.get(tiposEventosApi, {
    headers: await token({}),
    params,
  });
  return res;
};

export const saveTiposEventosService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.put(`${tiposEventosApi}/${id}`, data, {
      headers: await token({}),
    });
  } else {
    res = await axios.post(`${tiposEventosApi}`, data, {
      headers: await token({}),
    });
  }
  return res.data;
};

export const getOneTiposEventosService = async (id) => {
  const res = await axios.get(`${tiposEventosApi}/${id}`, {
    headers: await token({}),
  });
  return res;
};

export const deleteTiposEventosService = async (id) => {
  const res = await axios.delete(`${tiposEventosApi}/${id}`, {
    headers: await token({}),
  });
  return res;
};
